// src/systems/notificationSystem.ts — Fase 5 feedback reutilizable
export type NotifType = 'info'|'success'|'warning'|'mission'|'levelup'|'item';

export function notify(message:string, type:NotifType='info', duration=2800): void {
  let stack = document.querySelector<HTMLDivElement>('.toast-stack');
  if(!stack){ stack=document.createElement('div'); stack.className='toast-stack'; document.body.appendChild(stack); }
  const el=document.createElement('div');
  el.className='toast';
  const colors: Record<NotifType,string> = {
    info:'rgba(14,20,42,.96)',
    success:'rgba(18,60,30,.96)',
    warning:'rgba(60,40,10,.96)',
    mission:'rgba(30,20,60,.96)',
    levelup:'rgba(60,30,80,.96)',
    item:'rgba(20,40,60,.96)'
  };
  el.style.background = colors[type] ?? colors.info;
  if(type==='mission') el.style.borderColor='rgba(124,240,255,.4)';
  if(type==='levelup') el.style.borderColor='rgba(255,207,107,.5)';
  el.textContent = message;
  // icono simple
  const icons: Record<NotifType,string> = { info:'ℹ️', success:'✅', warning:'⚠️', mission:'📜', levelup:'⬆️', item:'🎒' };
  el.textContent = `${icons[type] ?? ''} ${message}`;
  stack.appendChild(el);
  setTimeout(()=> el.remove(), duration);
}

export function notifyMission(text:string){ notify(text,'mission', 3500); }
export function notifyLevelup(text:string){ notify(text,'levelup', 3800); }
export function notifyItem(text:string){ notify(text,'item', 3000); }
